var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"info-label"},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]),_c('td',[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }